import {
  isObject,
  isOriginAllowed,
  sendMessage
} from './deposits-bank-recommendation-widget'

function receiveMessage(event) {
  const { origin, data } = event

  if (process.env.APP_ENV !== 'local' && !isOriginAllowed(origin)) return
  if (!isObject(data) || !data.type) return

  switch (data.type) {
    case 'reco-widget.CLOSE': {
      window.disableRecoWidget()
      break
    }
    case 'reco-widget.RESULTS': {
      window.disableRecoWidget()
      window.location.href = data.value.redirectPath
      break
    }
    case 'reco-widget.READY': {
      const utmParam = 'utm_content=bank_reco_banner_ed_8_24'
      sendMessage({
        type: 'reco-widget.BOOTSTRAP',
        value: { utmParam }
      })
      break
    }
  }
}

const recoIframe = document.getElementById('deposits-reco-widget')
const recoWidget = document.querySelector('.reco-widget-cta')
const recoCta = document.querySelector('.reco-widget-cta__wrapper')
const recoCtaButton = document.querySelector('.reco-widget-cta__button-wrapper')

recoCtaButton.addEventListener('click', showWidget)

function showWidget() {
  recoCta.classList.add('--hidden')
  recoIframe.classList.remove('--hidden')
}

function enableRecoWidget() {
  recoWidget.classList.remove('--hidden')
}

function disableRecoWidget() {
  recoWidget.classList.add('--hidden')
}

window.enableRecoWidget = enableRecoWidget
window.disableRecoWidget = disableRecoWidget

window.addEventListener('message', receiveMessage, false)
